import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TimeFormatPipe } from './time-format.pipe';

export type AppointmentData = {
  allDay?: boolean;
  date?: string;
  endTime?: string;
  startTime?: string;
  appointmentDateSelected?: string;
  appointmentSlotSelected?: string;
};

@Pipe({
  name: 'dateTimeslot',
  standalone: true,
})
export class DateTimeslotPipe implements PipeTransform {
  constructor(
    private datePipe: DatePipe,
    private timeFormatPipe: TimeFormatPipe
  ) {}
  transform(value: AppointmentData | undefined): unknown {
    if (!value) return '';

    const date = value?.date;
    if (!date) return '';
    const formattedDate = this.datePipe.transform(date, 'EEEE d MMMM y');

    const startTime = value?.startTime;
    const endTime = value?.endTime;

    let formattedTime = 'All day';
    if (startTime && endTime) {
      formattedTime = `${this.timeFormatPipe.transform(startTime)} - ${this.timeFormatPipe.transform(endTime)}`;
    }

    return `${formattedDate}, ${formattedTime}`;
  }
}
